/* Wow custom */
(function ($) {
  var $ = (jQuery = $);
  var $document = $(document);

  $document.on("keypress", "textarea.tpo_option-input", function (e) {
    $target = $(e.target);
    let maxCharText = $target.next('.tpo_text-area-character-count').find('.tpo-max-character');
    if(maxCharText){
      let maxCharCount = parseInt(maxCharText.text().replace('/', ''));
      if($target.val().length >= maxCharCount){
        e.preventDefault();
        return false;
      }
    }
  });

  $document.on("input", "textarea.tpo_option-input", function (e) {
    $target = $(e.target);
    let maxCharText = $target.next('.tpo_text-area-character-count').find('.tpo-max-character');
    if(maxCharText){
      let maxCharCount = parseInt(maxCharText.text().replace('/', ''));
      if($target.val().length >= maxCharCount){
        $target.val($target.val().substring(0, maxCharCount));
      }
    }
  });

    $document.on("keypress", '[name="properties[Custom Year]"]', function (e) {
    $target = $(e.target);
    let maxCharCount = 8;
    let prevent = true;
    if (e.key >= "0" && e.key <= "9") {
      prevent = false;
      if($target.val().length >= maxCharCount){
        prevent = true;
      }
    }
    if(prevent){
      $target.val($target.val().substring(0, maxCharCount));
      e.preventDefault();
      return false;
    }
  });

  $document.on("input", '[name="properties[Custom Year]"]', function (e) {
    $target = $(e.target);
    let maxCharCount = 8;
    let prevent = true;
    if (e.key >= "0" && e.key <= "9") {
      prevent = false;
      if($target.val().length >= maxCharCount){
        prevent = true;
      }
    }
    if(prevent){
      $target.val($target.val().substring(0, maxCharCount));
    }
  });

  var wow = {
    single_price: parseFloat($('.theme-money.large-title').text().substring(1)),
    tiers: [1]
  };

  function setProductPrice(){
    if($(".price-grid").length === 0) return;
    let quant = $("input.quantity__number").val();
    let notePrice = $('.tpo_additional-price.active').text().slice(2, -1);
    if(notePrice === ''){
      notePrice = 0;
    } else {
      notePrice = parseFloat(notePrice);
    }

    let totalPrice = '$'+(notePrice + (wow.single_price * quant)).toFixed(2);
    $(".theme-money.large-title").text(totalPrice);
  }

  if ($(".price-grid .grid-table").length) {
    $(".price-grid .grid-table thead th:first").text("Quantity");
    $(".grid-table tbody tr:first-child").addClass("active");
    $(".price-grid .grid-table tbody tr").on("click", function () {
      $(".grid-table tbody tr").removeClass("active");
      $(this).addClass("active");

      let selectedPrice = $(this).find(".price-cell").text().trim();
      // $(".theme-money.large-title").text(selectedPrice);

      let firstCellText = $(this).find("td:first").text().trim();
      let secondCellText = $(this).find("td:first").next().text().trim();

      let firstNumberStr = firstCellText.split(/[-\s]/)[0];
      let secondNumber = parseFloat(secondCellText.substring(1));

      firstNumberStr = firstNumberStr.replace(/[,+]/g, "");

      if (!/^\d+$/.test(firstNumberStr)) {
        firstNumberStr = "";
      }

      wow.single_price = secondNumber;
      $(".input-text.quantity__number").val(firstNumberStr).trigger('change');
       
    });

    $(".grid-table tbody tr").each(function(i, e){
      let qty = $(e).find('.qty-cell').text().slice(0, -1);
      if(qty > 1){
        wow.tiers.push(parseInt(qty));
      }
    });

    var defprice = $('.theme-money.large-title').text();
  
    $('<div class="product-detail__price product-price priceclone" data-price-wrapper=""><span class="" data-product-price="" data-product-detail-price=""><span class="theme-money large-title">'+defprice+'</span></span></div>').insertBefore(".qty-addtocart");
  }

  $(".price-grid .grid-table .price-cell").each(function () {
    let text = $(this).text();
    $(this).text(text.replace(" USD", ""));
  });

  $(".price-grid .grid-table td").each(function () {
    if ($(this).text().trim() === "1+") {
      $(this).text("1 (Sample)");
    }
    if ($(this).text().trim() === "2+") {
      $(this).text("2-24");
    }
    if ($(this).text().trim() === "25+") {
      $(this).text("25-49");
    }
    if ($(this).text().trim() === "50+") {
      $(this).text("50-99");
    }
    if ($(this).text().trim() === "100+") {
      $(this).text("100-299");
    }
    if ($(this).text().trim() === "300+") {
      $(this).text("300-499");
    }
    if ($(this).text().trim() === "500+") {
      $(this).text("500-999");
    }
      if ($(this).text().trim() === "1000+") {
        $(this).text("1000-4999");
      }
    
    if (
      $(
        "#bulk-custom-logo-cookies-individually-wrapped-logo-cookies-cookie-bouquets"
      ).length
    ) {
      if ($(this).text().trim() === "1000+") {
        $(this).text("1000-4499");
      }
    }
    if ($(this).text().trim() === "1000+") {
      $(this).text("1000+");
    }
    if ($(this).text().trim() === "2500+") {
      $(this).text("2500+");
    }

    if ($("#custom-logo-cookies-circle").length) {
      if ($(this).text().trim() === "1000+") {
        $(this).text("1000-4999");
      }
    }

    if (
      $(
        "#photo-cookies-delivered-custom-photo-amp-logo-cookies-cookie-bouquets"
      ).length
    ) {
      if ($(this).text().trim() === "1,000+") {
        $(this).text("1000-4999");
      }
    }

    if ($("#custom-cookie-packaging").length) {
      if ($(this).text().trim() === "2-24") {
        $(this).text("2-100");
      }

      if ($(this).text().trim() === "101+") {
        $(this).text("101-300");
      }

      if ($(this).text().trim() === "301+") {
        $(this).text("301-500");
      }

      if ($(this).text().trim() === "501+") {
        $(this).text("501-1000");
      }

      if ($(this).text().trim() === "1001+") {
        $(this).text("1001-9999");
      }
    }
  });

  if ($("#custom-cookie-packaging").length) {
    $(
      '<p class="wpc-layer-description">*1 sample allowed per order. Minimum 10 cookies per design.</p><p class="f-red cpc-title2">Customize Your Cookies</p>'
    ).insertAfter(".price-grid");
  }

  console.log("Add-on product handle:", "teddy-bear");
  fetch(`/products/teddy-bear.js`)
    .then((response) => response.json())
    .then((product) => {
      console.log("Add-on product data:", product);
      console.log("First variant ID:", product.variants[0].id);
    });

  $(".teddyb").on("click", function () {
    $(".teddyb").toggleClass("open");
    $(".teddybox").slideToggle();
  });

  $(".teddybox .add-addon-to-cart").on("click", function (e) {
    e.preventDefault();
    $(this)
      .attr("disabled", "disabled")
      .each(function () {
        var contentFunc = $(this).is("button") ? "html" : "val";
        $(this)
          .data("previous-value", $(this)[contentFunc]())
          [contentFunc](theme.strings.addingToCart);
      });
    addToCartWithNotify("41847674536034", "1", this);
  });

  $(".ajax-product-form").each((index, el) => {
    // $(el).on("submit", function (e) {
    //   e.preventDefault();

    //   const formData = new FormData(el);

    //   fetch("/cart/add.js", {
    //     method: "POST",
    //     body: formData,
    //     headers: {
    //       "X-Requested-With": "XMLHttpRequest",
    //       Accept: "application/json",
    //     },
    //   })
    //     .then((response) => response.json())
    //     .then((data) => {})
    //     .catch((error) => {
    //       console.error("Error adding to cart:", error);
    //     });
    // });
  });

  var maxQuant = 9999;
  var maxLength = 4;
  $("#Quantity").attr("max", maxQuant);
  if($(".price-grid").length){
    maxQuant = 99999;
    maxLength = 5;
  }

  const wowObserver = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === 1 &&
            node.classList?.contains("quickbuy__product-media-item")
          ) {
            maxQuant = 9999;
            maxLength = 4;
            $("#Quantity").attr("max", maxQuant);
          }
        });
      }
    }
  });
  wowObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Quantity selector
  $document.on(
    "click",
    ".qty-wrapper .quantity__minus, .qty-wrapper .quantity__plus",
    function (e) {
      e.preventDefault();
      var $input = $(this)
        .closest(".quantity__change")
        .find(".quantity__number");
      if ($(this).hasClass("quantity__minus")) {
        $input.val(Math.max(parseInt($input.val()) - 1, 1));
      } else {
        $input.val(Math.min(parseInt($input.val()) + 1, maxQuant));
      }
      $input[0].dispatchEvent(new Event('input', { bubbles: true }));
      $input[0].dispatchEvent(new Event('change', { bubbles: true }));
      return false;
    }
  );

  $document.on("input", "input.quantity__number", function (e) {
    if (e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength);
    }
  });

  $document.on("change", "input.quantity__number", function (e) {
    if (this.value < 1) {
      this.value = 1;
    }
    if (this.value > maxQuant) {
      this.value = maxQuant;
    }
    let highest = 0;
    thisval = parseInt(this.value);
    wow.tiers.forEach(function(e, i){
      if(thisval >= e){
        highest = i;
      }
    });
    wow.single_price = parseFloat($(".grid-table tbody tr").eq(highest).find('.price-cell').text().substring(1));
    $(".grid-table tbody tr.active").removeClass('active');
    $(".grid-table tbody tr").eq(highest).addClass('active');
    setProductPrice();
  });

  
  $document.on('change', '.tpo_radio-button', function(e){
    setProductPrice();
  });

  // Collection filters
  function waitForSwiper(callback) {
    // Check every 100ms to see if Swiper is available
    var interval = setInterval(function() {
        if (typeof Swiper !== 'undefined') {
            clearInterval(interval);  // Stop checking once it's available
            callback();  // Execute the callback function
        }
    }, 100);
  }

  function calculateOffset(){
    let offset;
    if(window.innerWidth > 1600){
      let add = ($('.cc-filters-container')[0].offsetLeft - $('[data-section-type="collection-template"]')[0].offsetLeft) / 2;
      offset = ($(".shop-by").outerWidth(true) + $this[0].offsetLeft) + ($this.outerWidth() / 2) + add;
    } else if(window.innerWidth > 1400){
      offset = ($(".shop-by").outerWidth(true) + $this[0].offsetLeft) + ($this.outerWidth() / 2);
    } else if(window.innerWidth > 768){
      offset = 30 + $this[0].offsetLeft + ($this.outerWidth() / 2);
    } else {
      offset = 20 + $this[0].offsetLeft + ($this.outerWidth() / 2);
    }
    $(".custom-top-categories .inner .arrow-before").css("left", offset + "px");
    $(".custom-top-categories .inner .arrow-after").css("left", offset + "px");

    let offset2 = 20;
    let height = $(".custom-top-categories").height();
    if(window.innerWidth<=1400){
      if(window.innerWidth<=567){
          offset2 = 5;
      }
      $(".cc-filters").css('margin-top', height+offset2+'px');
    } else {
      $(".cc-filters").css('margin-top', '0px');
    }
  }

  let swipers = [];
  function show_swiper($this){
    $(".left-inner .showing").removeClass('showing');
    $this.addClass('showing');
    let index = $this.index();

    $(".category-swiper:visible").hide();
    $(".category-swiper").eq(index).show();
    $(".custom-top-categories .inner").addClass("active");
    $(".custom-top .active").removeClass("active");
    $(".custom-top").addClass("active");

    calculateOffset();

    if (swipers[index]) {
        swipers[index].update();
    }
  }

  function hide_swiper(changed = false) {
    $(".category-swiper:visible").hide();
    $(".custom-top-categories .inner").removeClass("active");
    $(".custom-top").removeClass("active");
    $(".left-inner .showing").removeClass('showing');
    if(changed){
        let original = $(".custom-top .current").data('original');
        console.log(original);
        $(".custom-top .current").text(original);
    } else {
        $(".custom-top .current").addClass('active');
    }
    if(window.innerWidth<=1400){
        $(".cc-filters").css('margin-top', 0);
    }
  }

  $document.on("click", ".left-inner .filter-button", function (e) {
    e.preventDefault();
    $this = $(this);
    if($this.hasClass('showing')){
      hide_swiper();
    } else {
      show_swiper($this);
    }
  });

  function initCollectionSwiper(){
    swipers = [];
    $(".category-swiper").each(function (i, e) {
      swipers[i] = new Swiper(e, {
        centeredSlides: false,
        slidesPerView: 2.7,
        spaceBetween: 10,
        height: 129,
        allowTouchMove: true,
        initialSlide: 1,
        navigation: {
          nextEl: $(e).find(".swiper-button-next")[0],
          prevEl: $(e).find(".swiper-button-prev")[0],
        },
        breakpoints: {
          992: {
            centeredSlides: false, 
            slidesPerView: "auto",
            spaceBetween: 36,
            height: 129,
            height: 367,
            allowTouchMove: false,
            initialSlide: 0,
          }
        }
      });
    });
  }

  waitForSwiper(function(){

    initCollectionSwiper();
    let shopBySwiper = null;
    function shopBySwiperCheck() {
      if (window.innerWidth < 993 && shopBySwiper == null) {
        shopBySwiper = new Swiper(".shop-by-swiper", {
          slidesPerView: "auto",
          spaceBetween: 6,
          freeMode: true,
          allowTouchMove: true,
          resistanceRatio: 0,
          slidesOffsetAfter: 20,
        });
        shopBySwiper.update();
      } else if (window.innerWidth >= 993 && shopBySwiper != null) {
        shopBySwiper.destroy();
        shopBySwiper = null;
      }
    }
    shopBySwiperCheck();
    $(window).on("resize", function () {
      shopBySwiperCheck();
      if($(".left-inner .showing")){
        calculateOffset();
      }
    });

    $document.on('filters-applied', function(e){
      initCollectionSwiper();
    });
  });

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.ymq-option-tooltip').forEach(el => {
      if (el._tippy && !el._tippy.state.isDestroyed) el._tippy.destroy();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  $document[0].addEventListener('click', function(event){
    if(event.target.tagName === 'DIV' && event.target.classList.length === 0){
      if($(".sr-only").length == 0){
        $(".yotpo-score-filter-container .yotpo-selected-value__label--inside").hide();
        $(".yotpo-score-filter-container .yotpo-dropdown-label--inside").hide();
      } else {
        $(".yotpo-score-filter-container .yotpo-selected-value__label--inside").show();
        $(".yotpo-score-filter-container .yotpo-dropdown-label--inside").show();
      }
    }
  }, true);

  
})(theme.jQuery);
/* Wow custom END */
